import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    container: {
        border: `1px solid`,
        position: "relative",
    },
    info_section: {
        display: "flex",
        borderBottom: `1px solid`,
        "& > div": {
            padding: theme.spacing(0.5),
        },
        "& > div:not(:last-child)": {
            borderRight: `1px solid`,
        },
    },
    main_section: {
        display: "flex",
    },
}))